import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BrushMark from "@/components/BrushMark";

const NAV = [
  { to: "/expertise", label: "Services" },
  { to: "/people", label: "People" },
  { to: "/insights", label: "Insights" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 12);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 bg-warmwhite transition-shadow ${scrolled ? "hairline-bottom" : ""}`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-20 md:h-24">
          <BrushMark size={64} />

          <nav className="hidden md:flex items-center gap-10">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-[0.82rem] tracking-[0.18em] uppercase font-medium transition-colors ${isActive ? "text-[#1E3668]" : "text-graphite hover:text-[#1E3668]"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="header-cta"
              className="cec-btn cec-btn-primary"
            >
              Make an enquiry
            </Link>
          </nav>

          <button
            className="md:hidden p-2 -mr-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle navigation"
            data-testid="mobile-nav-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAFAF7] hairline-bottom" data-testid="mobile-nav-panel">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="text-xl font-semibold tracking-tight"
              >
                {n.label}
              </Link>
            ))}
            <Link to="/contact" className="cec-btn cec-btn-primary self-start mt-2" data-testid="mobile-cta">
              Make an enquiry
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
